import { grey } from "@mui/material/colors";

export const theme = {
  col_1: "#F5F5F5",
  col_2: "#EC6C83",
  col_3: "#3EACD6",
  col_4: "#FFFF",
  col_5: "#E2E2E2",
  col_6: "#5D535C",
  col_7: "#F3F4F9",
  col_8: "#94a4c4",
  col_9: "#ff9777",
  col_10: "#e5eaf2",
  col_11: "black",
  col_12: "#E68007",
  col_13: "red",
  col_14: "#17B8D9",
  col_15: "#EAB918",
  col_16: "#26D4C3",

  
  
  statusSuccessAlpha : "#ECFDF3",
  statusSuccess : "#027948",
  
  statusInfoAlpha : "#EAFBFF",
  statusInfo : "#008CB1",
  
  statusPendingAlpha : "#F9F5FF",
  statusPending : "#8260CF",
  
  statusWarningAlpha : "#FFF3C5",
  statusWarning : "#F7B700",
  
  statusDangerAlpha : "#FEF3F2",
  statusDanger : "#B4281D",
  
  statusDisabledAlpha : "#F2F4F7",
  statusDisabled : "#344054",
  
  
  
  
  grey: {
    50: grey[50],
    100: grey[100],
    200: grey[200],
    300: grey[300],
    400: grey[400],
    500: grey[500],
    600: grey[600],
    700: grey[700],
    800: grey[800],
    900: grey[900],
  },
  
  bgBorder: "rgb(229, 234, 242)",
  txtAlpha: "rgb(148, 164, 196)",
  col_2_alpha: "rgba(236, 108, 131, 0.3)",
  col_2_alpha_alt: "#f4bac5",
  col_2_alpha2: "rgba(254, 245, 246, 1)",
  col_3_alpha: "rgba(62, 172, 214, 0.3)",
  col_14_alpha: "rgba(238, 250, 253, 1)",
  col_15_alpha: "rgba(234, 185, 24, 0.19)",
};
